import { Colors } from '@domain/theming';
import { styled } from '@mui/material';

const Footer = styled('footer')`
  height: fit-content;
  min-height: 40px;
  padding: 10px;
  z-index: 0;
  background-color:${Colors.GREY_LIGHT};
  opacity: 0.85;
  color:${Colors.GREY_DARK};
`;

export default Footer;
